"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
exports.resourceCounts = graphql_tag_1.default `
  query resourceCounts {
    workflowsCount(archived: false)
    integrationsCount
    emailServiceProvidersCount
    contentSystemsCount
    emailTemplatesCount
    adsCount
    emailsCount
  }
`;
//# sourceMappingURL=home.js.map